import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import '../css/Sidebar.css'
import UserMenu from './UserMenu';
import api from './api/api';
import { 
  MessageSquare,
  BarChart2,
  BookOpen,
  User,
  AlertCircle,
  FileSearch,
 } from "lucide-react"
import { useUser } from './User/UserContext';


function Sidebar({selectedIcon, showMenu}) {
  const [showUser, setShowUser] = useState(false);
  const userInfo = useUser();

  return (
    <div className={`main-sidebar fixed top-0 left-0 h-[100vh] sm:h-[100svh] w-[90px] p-2.5 border-r-[5px] border-white flex flex-col items-center bg-[#333333] z-[5000] ${showMenu && '!flex'}`}>
      <div id="sidebar-icons">
        {/* Chat */}
        <div className='py-2'>
          <Link to="/chat">
            <div className={`sidebar-icon-block`}>
              {<MessageSquare 
                className={`rounded p-1 size-14 hover:text-white ${
                  selectedIcon === "chat" ? "text-white" : "text-gray-400"
                }`}
                strokeWidth={selectedIcon === "chat" ? 2 : 1}
                />}
            </div>
          </Link>
          <div className="sidebar-icon-desc">Chat</div>
        </div>
              
        {/* Analysis */}
        <div className='py-2'>
          <Link to="/analysis">
            <div className={`sidebar-icon-block `}>
              <BarChart2 
                className={`rounded p-1 size-14 hover:text-white ${
                  selectedIcon === "analysis" ? "text-white" : "text-gray-400"
                }`}
                strokeWidth={selectedIcon === 'analysis' ? 2 : 1} 
              />

            </div>
          </Link>
          <div className="sidebar-icon-desc">Analysis</div>
        </div>

        {/* Daily Report */}
        {/* <Link to="/daily-report-list">
          <div className={`sidebar-icon-block ${selectedIcon === "daily-report" ? "sidebar-icon-selected" : ""}`}>
            <FontAwesomeIcon icon={faFileLines} className='sidebar-icon'/>
          </div>
        </Link>
        <div className="sidebar-icon-desc">Daily Report</div> */}

        {userInfo?.is_business_user && (
          <div className='py-2'>
            {/* Research */}
            <Link to="/research">
            <div className={`sidebar-icon-block`}>
              <FileSearch 
                className={`rounded p-1 size-14 hover:text-white ${
                  selectedIcon === "research" ? "text-white" : "text-gray-400"
                }`}
                strokeWidth={selectedIcon === 'research' ? 2 : 1} 
              />
            </div>
            </Link>
            <div className="sidebar-icon-desc">Research</div>
          </div>
        )}

        {/* Insight Note */}
        <div className='py-2'>
          <Link to="/insight-note">
            <div className={`sidebar-icon-block`}>
              <BookOpen 
                className={`rounded p-1 size-14 hover:text-white ${
                  selectedIcon === "insight-note" ? "text-white" : "text-gray-400"
                }`}
                strokeWidth={selectedIcon === 'insight-note' ? 2 : 1} 
              />

            </div>
          </Link>
          <div className="sidebar-icon-desc">Insight Note</div>
        </div>      
          
        {/* user */}
        <div className='py-2'>
          <div className={`sidebar-icon-block`}
            onMouseOver={() => setShowUser(true)}
            onMouseLeave={() => setShowUser(false)}
          >
            <User 
              className={`rounded p-1 size-14 hover:text-white ${
                selectedIcon === "user" ? "text-white" : "text-gray-400"
              }`}strokeWidth={selectedIcon === 'user' ? 2 : 1} 
            />
            {showUser ? <UserMenu />: null}
          </div>
          <div className="sidebar-icon-desc">User</div>
        </div>
      </div>
      <div className="bottom-sidebar">
          <Link to="/term-of-use">
              <div className={`sidebar-icon-block`}>
                <AlertCircle 
                  id="" 
                  className="rounded p-1 size-14 hover:text-white " 
                  strokeWidth={selectedIcon === 'alert' ? 2 : 1} 
                />
              </div>
          </ Link>
          <div className="sidebar-icon-desc text-white">利用上の注意</div>
      </div>
    </div>
  );
}

export default Sidebar;
